import {useState} from "react"
import {apiRoomParameters} from "./Api"

const CEILING_CONSTITUTIONS = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "ceiling_a", name: {de_DE: "CEILING_CONSTITUTIONS A-DE", en_GB: "CEILING_CONSTITUTIONS A-EN"}},
    {code: "ceiling_b", name: {de_DE: "CEILING_CONSTITUTIONS B-DE", en_GB: "CEILING_CONSTITUTIONS B-EN"}},
]
const WALL_CONSTITUTIONS = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "wall_a", name: {de_DE: "WALL_CONSTITUTIONS A-DE", en_GB: "WALL_CONSTITUTIONS A-EN"}},
    {code: "wall_b", name: {de_DE: "WALL_CONSTITUTIONS B-DE", en_GB: "WALL_CONSTITUTIONS B-EN"}},
]
const FLOOR_CONSTITUTIONS = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "floor_a", name: {de_DE: "FLOOR_CONSTITUTIONS A-DE", en_GB: "FLOOR_CONSTITUTIONS A-EN"}},
    {code: "floor_b", name: {de_DE: "FLOOR_CONSTITUTIONS B-DE", en_GB: "FLOOR_CONSTITUTIONS B-EN"}},
]

const WINDOW_TYPES = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "floor_a", name: {de_DE: "WINDOW_TYPES A-DE", en_GB: "WINDOW_TYPES A-EN"}},
    {code: "floor_b", name: {de_DE: "WINDOW_TYPES B-DE", en_GB: "WINDOW_TYPES B-EN"}},
]

const DOOR_HANDLE_POSITIONS = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "a", name: {de_DE: "DOOR_HANDLE_POSITIONS A-DE", en_GB: "DOOR_HANDLE_POSITIONS A-EN"}},
    {code: "b", name: {de_DE: "DOOR_HANDLE_POSITIONS B-DE", en_GB: "DOOR_HANDLE_POSITIONS B-EN"}},
]

const DOOR_TYPES = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "a", name: {de_DE: "DOOR_TYPES A-DE", en_GB: "DOOR_TYPES A-EN"}},
    {code: "b", name: {de_DE: "DOOR_TYPES B-DE", en_GB: "DOOR_TYPES B-EN"}},
]

const DOOR_OPENING_DIRECTIONS = [
    {code: null, name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}},
    {code: "a", name: {de_DE: "DOOR_OPENING_DIRECTIONS A-DE", en_GB: "DOOR_OPENING_DIRECTIONS A-EN"}},
    {code: "b", name: {de_DE: "DOOR_OPENING_DIRECTIONS B-DE", en_GB: "DOOR_OPENING_DIRECTIONS B-EN"}},
]

const PREPARED_ROOMS = {
    livingroom: [
        {
            name: {de_DE: "Musterraum (20m²) laden", en_GB: "Load sample room (20m²)"},
            code: "CHE ECP 3RT US3"
        },
        {
            name: {de_DE: "Musterraum (40m²) laden", en_GB: "Load sample room (40m²)"},
            code: "CHE ECP 3RT US3"
        }
    ]
}

const useRoomParameters = () => {
    const [roomParameters, setRoomParameters] = useState(null)

    const load = () => {
        apiRoomParameters()
            .then(data => setRoomParameters(data.shift()))
            .catch(error => console.error(error))
    }

    const getRoomTypeByCode = (roomCode) => roomParameters.roomTypes.find(room => room.code === roomCode)

    const getRoomShapeByCode = (shapeCode) => roomParameters.roomShapes.find(shape => shape.code === shapeCode)

    const getDimensions = (shape, room) => {
        return getRoomShapeByCode(shape).defaultSize[room]
    }

    const getPreparedRooms = (roomType) => {
        return PREPARED_ROOMS?.[roomType] || []
    }

    const getCeilingConstitutions = () => {
        const ceilingConstitutions = roomParameters.surfaceStructures.filter(surfaceStructure => {
            const test = new RegExp('^ceiling-*', );
            return test.test(surfaceStructure.code)
        })
        ceilingConstitutions.unshift({code: "", name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}})
        return ceilingConstitutions
    }
    const getWallConstitutions = () => {
        const wallConstitutions = roomParameters.surfaceStructures.filter(surfaceStructure => {
            const test = new RegExp('^wall-*', );
            return test.test(surfaceStructure.code)
        })
        wallConstitutions.unshift({code: "", name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}})
        return wallConstitutions
    }
    const getFloorConstitutions = () => {
        const floorConstitutions = roomParameters.surfaceStructures.filter(surfaceStructure => {
            const test = new RegExp('^floor-*', );
            return test.test(surfaceStructure.code)
        })
        floorConstitutions.unshift({code: "", name: {de_DE: "-- bitte wählen --", en_GB: "-- please choose --"}})
        return floorConstitutions
    }

    const getImpressions = (roomType) => {
        return roomParameters.impressions.filter(impression => impression.roomTypes.includes(roomType))
    }

    return {
        load: () => load(),
        isLoaded: () => roomParameters !== null,
        getRoomParameters: () => roomParameters,
        getRoomTypes: () => roomParameters.roomTypes,
        getRoomTypeByCode,
        getRoomShapes: () => roomParameters.roomShapes,
        getRoomShapeByCode,
        getDimensions,
        getInteriors: (interiorType, roomType) => {
            return roomParameters?.interiors.filter(interior =>
                (Array.isArray(interior.roomTypes) && interior.roomTypes.length)
                    ? (interior.type === interiorType && interior.roomTypes.includes(roomType))
                    : (interior.type === interiorType)
            ) ?? []
        },
        getNoises: (roomType) => {
            const roomNoiseSourceCodes = roomParameters.roomTypes.find(room => room.code === roomType).noiseSources
            if (roomNoiseSourceCodes) {
                return roomParameters.noiseSources.filter(noiseSource => roomNoiseSourceCodes.includes(noiseSource.code))
            }

            return roomParameters.noiseSources
        },

        getNoise: (code) => {
            return roomParameters.noiseSources.find(room => room.code === code)
        },

        getBudgets: (roomTypeCode) => roomParameters.roomTypes.find(roomType => roomType.code === roomTypeCode).budgets,
        getFireProtectionClasses: () => roomParameters.fireProtectionClasses.sort((a, b) => {
            if (a.priority > b.priority) return 1
            if (a.priority < b.priority) return -1
            return 0
        }),
        getInteriorById: id => roomParameters.interiors.find(interior => interior.id === id),
        getCeilingConstitutions,
        getWallConstitutions,
        getFloorConstitutions,
        getWindowTypes: () => WINDOW_TYPES,
        getDoorHandlePositions: () => DOOR_HANDLE_POSITIONS,
        getDoorTypes: () => DOOR_TYPES,
        getDoorOpeningDirections: () => DOOR_OPENING_DIRECTIONS,
        getPreparedRooms,
        getImpressions,
    }
}

export {useRoomParameters}
